import { SOCKET_EVENTS } from '@/api/socket-events';
import { socket } from '@/api/socket';
import {
	$appendBuildLogs,
	$buildLiveProgress,
	$buildLogs,
	$clearBuildLive,
	$updateBuildProgress,
	type IBuildLiveProgress,
	type IBuildLogLine,
} from '@/entities/build-live.entity';
import { useUnit } from 'effector-react';
import { useEffect } from 'react';

export function useBuildSubscription(buildId: string | null | undefined) {
	const [progressMap, logsMap, updateProgress, appendLogs, clearLive] = useUnit([
		$buildLiveProgress,
		$buildLogs,
		$updateBuildProgress,
		$appendBuildLogs,
		$clearBuildLive,
	]);

	useEffect(() => {
		if (!buildId || !socket) return;

		const subscribe = () => {
			socket.emit(SOCKET_EVENTS.subscribeBuild, { buildId });
		};

		if (socket.connected) {
			subscribe();
		}

		socket.on('connect', subscribe);

		return () => {
			socket.off('connect', subscribe);
			socket.emit(SOCKET_EVENTS.unsubscribeBuild, { buildId });
			clearLive(buildId);
		};
	}, [buildId, clearLive]);

	const progress: IBuildLiveProgress | null = buildId ? progressMap[buildId] ?? null : null;
	const logs: IBuildLogLine[] = buildId ? logsMap[buildId] ?? [] : [];

	return { progress, logs, updateProgress, appendLogs };
}
